import { render, staticRenderFns } from "./CreateItineraryFormTextarea.vue?vue&type=template&id=5a10e8ab&scoped=true&"
import script from "./CreateItineraryFormTextarea.vue?vue&type=script&lang=js&"
export * from "./CreateItineraryFormTextarea.vue?vue&type=script&lang=js&"
import style0 from "./CreateItineraryFormTextarea.vue?vue&type=style&index=0&id=5a10e8ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a10e8ab",
  null
  
)

export default component.exports